<template>
  <div class="frame5">
    <div class="frame5_top_title">
      <img
        src="../../../../public/img/shares_Info/vip2.png"
        class="frame5_top_img1"
      />
      体验小钱书VIP特权
      <img
        src="../../../../public/img/shares_Info/close.png"
        class="frame5_top_img2"
      />
    </div>
    <div class="frame5_content">
      今日可免费查看2只基金VIP尊享详情开通小钱书VIP畅享无限次查看特权
    </div>
    <div class="frame5_bottom">
      <div class="frame5_bottom_text1">开通小钱书VIP</div>
      <div class="frame5_bottom_text2">先体验查看</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.frame5 {
  width: 238px;
  height: 283px;
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  position: fixed;
  top: calc(50% - 119px);
  left: calc(50% - 160px);
  z-index: 9999999;
  padding: 28px 41px 28px 41px;
}
.frame5_top_title {
  width: 100%;
  text-align: center;
  color: #e7aa55;
  font-size: 20px;
  font-weight: 550;
  position: relative;
  line-height: 1;
}
.frame5_top_img1 {
  width: 23px;
  height: 20px;
  vertical-align: middle;
}
.frame5_top_img2 {
  width: 15px;
  height: 15px;
  vertical-align: middle;
  margin-left: 10px;
  position: absolute;
  right: -17px;
  top: 4px;
}
.frame5_content {
  font-size: 18px;
  line-height: 1.8;
  color: #625543;
  letter-spacing: 0px;
  margin-top: 25px;
}
.frame5_bottom {
  margin-top: 30px;
}
.frame5_bottom_text1 {
  width: 194px;
  height: 42px;
  border-radius: 21px;
  border: solid 1px #ddbc84;
  font-size: 18px;
  line-height: 42px;
  color: #ddbc84;
  text-align: center;
  margin: 0 auto;
  cursor: pointer;
}
.frame5_bottom_text2 {
  width: 194px;
  height: 42px;
  background-image: linear-gradient(-20deg, #e1a859 0%, #ffc370 100%),
    linear-gradient(#000000, #000000);
  background-blend-mode: normal, normal;
  border-radius: 21px;
  font-size: 18px;
  line-height: 42px;
  color: #ffffff;
  text-align: center;
  margin: 0 auto;
  margin-top: 10px;
  cursor: pointer;
}
</style>